import { FC, useContext } from 'react';
import Context from '../context';

import { Resources } from './resources';

export const CostOutputTable: FC<{}> = () => {
    const { state } = useContext(Context);
    const {
        blobReadBestGuess,
        blobReadMin,
        blobReadMax,
        blobWriteBestGuess,
        blobWriteMin,
        blobWriteMax,
        queueBestGuess,
        queueMin,
        queueMax,
        tableBestGuess,
        tableMin,
        tableMax
    } = state.operationCountData;
    const monthlyRuns = state.monthlyRuns;

    function numberWithCommas(x: number) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function createRow(rowLabel: string, min: number, max: number, bestGuess: number, isStyleLight: boolean, isPerMonth: boolean) {
        const rowClassName = isStyleLight ? "cost-output-table-row-light" : "cost-output-table-row-dark";
        if (isPerMonth) {
            return (
                <div className={rowClassName}>
                    <div className="cell-bold">
                        <p>{rowLabel}</p>
                    </div>
                    <div className="cell">
                        <p>{numberWithCommas(min*monthlyRuns)}</p>
                    </div>
                    <div className="cell">
                        <p>{numberWithCommas(max*monthlyRuns)}</p>
                    </div>
                    <div className="cell">
                        <p>{numberWithCommas(bestGuess*monthlyRuns)}</p>
                    </div>
                </div>
            );
        } else {
            return (
                <div className={rowClassName}>
                    <div className="cell-bold">
                        <p>{rowLabel}</p>
                    </div>
                    <div className="cell">
                        <p>{numberWithCommas(min)}</p>
                    </div>
                    <div className="cell">
                        <p>{numberWithCommas(max)}</p>
                    </div>
                    <div className="cell">
                        <p>{numberWithCommas(bestGuess)}</p>
                    </div>
                </div>
            );
        }
    }

    return (
        <div className="cost-output-table">
            <div className="header-rotated-run"><div><span>{Resources.PER_RUN_LABEL}</span></div></div>
            <div className="cost-output-table-header">
                <div className="cell-bold">
                    <p>{Resources.OUTPUT_HEADER_OPERATION_LABEL}</p>
                </div>
                <div className="cell-bold">
                    <p>{Resources.OUTPUT_HEADER_MIN_LABEL}</p>
                </div>
                <div className="cell-bold">
                    <p>{Resources.OUTPUT_HEADER_MAX_LABEL}</p>
                </div>
                <div className="cell-bold">
                    <p>{Resources.OUTPUT_HEADER_BEST_GUESS_LABEL}</p>
                </div>
            </div>
            {createRow(Resources.OUTPUT_HEADER_BLOB_READ_LABEL, blobReadMin, blobReadMax, blobReadBestGuess, true, false)}
            {createRow(Resources.OUTPUT_HEADER_BLOB_WRITE_LABEL, blobWriteMin, blobWriteMax, blobWriteBestGuess, false, false)}
            {createRow(Resources.OUTPUT_HEADER_QUEUE_LABEL, queueMin, queueMax, queueBestGuess, true, false)}
            {createRow(Resources.OUTPUT_HEADER_TABLE_LABEL, tableMin, tableMax, tableBestGuess, false, false)}
            <div className="cost-output-table-row">
                <div className="cell">
                    <p></p>
                </div>
            </div>
            <div className="header-rotated-month"><div><span>{Resources.PER_MONTH_LABEL}</span></div></div>
            {createRow(Resources.OUTPUT_HEADER_BLOB_READ_LABEL, blobReadMin, blobReadMax, blobReadBestGuess, true, true)}
            {createRow(Resources.OUTPUT_HEADER_BLOB_WRITE_LABEL, blobWriteMin, blobWriteMax, blobWriteBestGuess, false, true)}
            {createRow(Resources.OUTPUT_HEADER_QUEUE_LABEL, queueMin, queueMax, queueBestGuess, true, true)}
            {createRow(Resources.OUTPUT_HEADER_TABLE_LABEL, tableMin, tableMax, tableBestGuess, false, true)}
        </div>
    );
}
